import { useEffect } from "react";
import { Star } from "lucide-react";
import { REVIEWS } from "@/data/site";
import { Reveal, MaskedLine } from "@/components/Reveal";
import { CTABand } from "@/components/CTABand";

const Stars = () => (
  <div className="flex gap-0.5">
    {[...Array(5)].map((_, i) => (
      <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />
    ))}
  </div>
);

export default function ReviewsPage() {
  useEffect(() => {
    document.title = "Reviews | Irvine Water Heater Man";
  }, []);

  return (
    <div>
      <section className="navy-grain text-white px-4 sm:px-6 pt-14 sm:pt-20 pb-16" data-testid="reviews-hero">
        <div className="max-w-7xl mx-auto">
          <h1 className="font-heading font-black tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.05] max-w-3xl">
            <MaskedLine>What Irvine Says</MaskedLine>
            <MaskedLine delay={0.15}><span className="text-[#FF6500]">About Our Work.</span></MaskedLine>
          </h1>
          <div className="flex items-center gap-4 mt-8">
            <span className="font-heading font-black text-6xl">5.0</span>
            <div>
              <div className="flex gap-1">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-6 h-6 fill-amber-400 text-amber-400" />
                ))}
              </div>
              <p className="text-white/60 text-sm mt-1">Homeowner reviews from across our service area</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-24 px-4 sm:px-6 bg-[#FAFAFA]" data-testid="reviews-grid">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.name} delay={(i % 3) * 0.06}>
              <div className="bg-white border border-gray-200 rounded-2xl p-7 h-full flex flex-col" data-testid={`reviews-page-card-${i}`}>
                <Stars />
                <p className="text-gray-700 leading-relaxed mt-4 mb-6 flex-1">"{r.text}"</p>
                <div>
                  <p className="font-heading font-bold text-gray-900">{r.name}</p>
                  <p className="text-gray-500 text-sm">{r.area} · {r.service}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <CTABand idPrefix="reviews-cta" />
    </div>
  );
}
